import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {InfluencerService} from '../../services/influencer/influencer.service';
import {AchooPopupComponent} from '../../core/achoo-popup/achoo-popup.component';
import {TranslateService} from '@ngx-translate/core';
import {ModalService} from '../../services/modal/modal.service';
import {StringUtils} from '../../utils/string.utils';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { EventTrackerService, UserActionType, Page, ActionSource, ActionDetails, TargetType } from '../../services/event-tracker/event-tracker.service';
import { CampaignService } from '../../services/campaign/campaign.service';
import { UserService } from '../../services/user.service';
import { InfluencerRequestError } from '../influencer-details/fail-retrieve-campaign-modal/fail-retrieve-campaign-modal.component';
import { Channel } from '../../../models/common';
import { platformIconPath, ChannelStatus, CommonConstant } from '../../app.constants';
import {AuthService} from '../../core/auth.service';

export enum AllSetPageType {
  CAMPAIGN_INVITATION = 'campaign_invitation',
  CONTACT_PERMISSION = 'contact_permission'
}
@Component({
  selector: 'influencer-all-set',
  templateUrl: './influencer-all-set.component.html',
  styleUrls: ['./influencer-all-set.component.scss']
})
export class InfluencerAllSetComponent implements OnInit {
  @ViewChild('AllSetPageNotification') allSetPageNotification: AchooPopupComponent;
  @ViewChild('AllSetPageErrorModal') allSetPageErrorModal: AchooPopupComponent;
  private requestType: string;
  private permissionToken: string;
  private campaignInfluencer: number;
  private campaignId: number;
  private isNewCampaign: boolean;
  private inviteToken: string;
  private accessToken: string;
  private hasConfirmedAllChannels: boolean;
  private influencerName: string;
  private advertiserName: string;
  private agencyName: string;
  private permissionId: number;
  private advertiserId: number;
  currentInfluencer;
  listExistingChannel: Channel[] = [];
  campaignData: any;
  notificationMessage: string;
  notificationType: string;
  urlQueryParams: any;
  title: string;
  isDeclined = false;
  isAcceptedOrRejected = false;
  errorType: InfluencerRequestError;
  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private influencerService: InfluencerService,
              private translate: TranslateService,
              private modalService: ModalService,
              private route: Router,
              private auth: AuthService,
              private eventTracker: EventTrackerService,
              private campaignService: CampaignService,
              private userService: UserService) { }

  ngOnInit() {
    this.currentInfluencer = this.userService.getInfluencerInfo();
    this.getQueryParams();
    if (this.campaignId) {
      this.campaignService.getCampaignOfInfluencer(this.currentInfluencer.id, this.campaignId).subscribe(res => {
        this.campaignData = res[0];
      });
    }
    this.loadInfluencerChannels(this.currentInfluencer.id);
  }

  private getQueryParams() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (!this.isValidLink(params.requestType)) {
        return this.router.navigate(['influencer', 'login']);
      }
      this.requestType = params.requestType;
      if (params.permissionToken) {
        this.permissionToken = params.permissionToken;
      }
      if (params.campaignInfluencerId) {
        this.campaignInfluencer = Number(params.campaignInfluencerId);
      }
      if (params.inviteToken) {
        this.inviteToken = params.inviteToken;
      }
      if (params.accessToken) {
        this.accessToken = params.accessToken;
      }
      if (params.campaignId) {
        this.campaignId = Number(params.campaignId);
      }
      if (params.isNewCampaign) {
        this.isNewCampaign = params.isNewCampaign;
      }
      if (params.influencerName) {
        this.influencerName = params.influencerName;
      }
      if (params.advertiserName) {
        this.advertiserName = params.advertiserName;
      }
      if (params.company) {
        this.agencyName = params.company;
      }
      if (params.permissionId) {
        this.permissionId = Number(params.permissionId);
      }
      if (params.advertiserId) {
        this.advertiserId = Number(params.advertiserId);
      }
    });
    this.urlQueryParams = combineLatest(
      this.activatedRoute.queryParams,
      (queryParams) => ({ ...queryParams})
    );

    this.urlQueryParams.subscribe(qp => {
      if (qp.acceptionResult && qp.acceptionResult === 'false' || qp.declineResult && qp.declineResult === 'false') {
        this.errorType = InfluencerRequestError.ACCEPT_OR_REJECT_API_FAIL;
        this.modalService.openInCenter(this.allSetPageErrorModal, null, 'all-set-page-error-modal', true);
      }
      if (qp.acceptionResult || this.isContactPermissionRequest) {
        this.title = this.translate.instant('all_set.title');
      }
      if (qp.declineResult && this.isCampaignInvitationRequest) {
        this.isDeclined = true;
        this.title = this.translate.instant('all_set.rejected_title');
      }
      if (qp.declineResult && this.isContactPermissionRequest) {
        this.isDeclined = true;
        this.title = this.translate.instant('all_set.rejected_contact_permission_title');
      }
    });
  }

  private isValidLink(requestType) {
    return requestType && (requestType === AllSetPageType.CONTACT_PERMISSION || requestType === AllSetPageType.CAMPAIGN_INVITATION);
  }

  get isCampaignInvitationRequest() {
    return this.requestType === AllSetPageType.CAMPAIGN_INVITATION;
  }

  get isContactPermissionRequest() {
    return this.requestType === AllSetPageType.CONTACT_PERMISSION;
  }

  get permissionContent() {
    if (!this.influencerName || !this.advertiserName || !this.agencyName) {
      return null;
    }
    const permissionParams = {
      influencerName: this.influencerName,
      advertiser: this.advertiserName,
      company: this.agencyName,
      advertiserName: this.advertiserName
    };
    if (!this.isDeclined && this.isContactPermissionRequest) {
      return this.translate.instant('all_set.content_permission', permissionParams);
    } else {
      return this.translate.instant('all_set.content_rejected_permission', permissionParams);
    }
  }

  acceptOrRejectPermission(isRetried: boolean) {
    this.isAcceptedOrRejected = true;
    if (!this.isDeclined) {
      this.rejectPermission(isRetried);
    } else {
      this.acceptPermission(isRetried);
    }
  }

  get revertPermissionLink() {
    if (this.isDeclined) {
      return this.translate.instant('all_set.accept_permission_link');
    } else {
      return this.translate.instant('all_set.reject_permission_link');
    }
  }

  get revertCampaignInvitationLink() {
    if (this.isDeclined) {
      return this.translate.instant('all_set.accept_campaign_link');
    } else {
      return this.translate.instant('all_set.reject_campaign_link');
    }
  }

  private rejectPermission(isRetried: boolean) {
    this.isDeclined = true;
    this.title = this.translate.instant('all_set.rejected_contact_permission_title');
    this.modalService.close();
    this.influencerService.rejectContactPermission(this.permissionToken).subscribe((res) => {
      this.sendMixpanelEvent(this.isDeclined);
      this.notifySuccess(this.translate.instant('all_set.success_permission_rejection'));
    }, (error) => {
      this.handleErrorOnContactPermission(isRetried);
    });
  }

  private acceptPermission(isRetried: boolean) {
    this.modalService.close();
    if (!this.hasConfirmedAllChannels) {
      this.influencerService.resetContactPermission(this.permissionToken).subscribe((res) => {
        return this.redirectToPreviousPage();
      });
    } else {
      this.isDeclined = false;
      this.title = this.translate.instant('all_set.title');
      this.influencerService.acceptContactPermission(this.permissionToken).subscribe((res) => {
        if (!isRetried) {
          this.sendMixpanelEvent(this.isDeclined);
        }
        this.notifySuccess(this.translate.instant('all_set.success_permission_acception'));
      }, (error) => {
        this.handleErrorOnContactPermission(isRetried);
      });
    }
  }

  private handleErrorOnContactPermission(isRetried) {
    this.isDeclined = true;
    this.title = this.translate.instant('all_set.rejected_contact_permission_title');
    if (!isRetried) {
      this.errorType = InfluencerRequestError.ACCEPT_OR_REJECT_API_FAIL;
    }
    this.modalService.openInCenter(this.allSetPageErrorModal, null, 'all-set-page-error-modal');
  }

  declineOrAcceptCampaignInvitation(isRetried: boolean) {
    this.isAcceptedOrRejected = true;
    if (this.campaignInfluencer && !this.isDeclined) {
      this.declineCampaign(isRetried);
    } else {
      this.accpetCampaign(isRetried);
    }
  }

  private notifyError(errorMessage) {
    if (errorMessage && StringUtils.trim(errorMessage) !== '') {
      this.notificationType = this.translate.instant('notification.error');
      this.notificationMessage = errorMessage;
      this.modalService.open(this.allSetPageNotification, () => {
        this.notificationType = null;
        this.notificationMessage = null;
      }, true);
    }
  }

  private notifySuccess(successMessage) {
    if (successMessage && StringUtils.trim(successMessage) !== '') {
      this.notificationType = this.translate.instant('notification.success');
      this.notificationMessage = successMessage;
      this.modalService.open(this.allSetPageNotification, () => {
        this.notificationType = null;
        this.notificationMessage = null;
      }, true);
    }
  }

  redirectToPreviousPage(isReAccept?) {
    if (this.isContactPermissionRequest) {
      return this.route.navigate(['dashboard', 'contact-permission'], {
        queryParams: {
          accessToken: this.accessToken,
          permissionToken: this.permissionToken
        }
      });
    }
    return this.route.navigate(['dashboard', 'campaigns', this.campaignId, 'new'], {
      queryParams: {
        isNewCampaign: this.isNewCampaign,
        inviteToken: this.inviteToken,
        campaignInfluencerId: this.campaignInfluencer,
        isReAccept
      }
    });
  }

  tryAgian() {
    if (!this.isAcceptedOrRejected) {
      this.redirectToPreviousPage();
    } else if (this.isAcceptedOrRejected && this.permissionToken) {
      this.acceptOrRejectPermission(true);
    } else {
      this.declineOrAcceptCampaignInvitation(true);
    }
  }

  private sendMixpanelEvent(isDeclined) {
    if (this.permissionToken) {
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CONTACT_PERMISSION, {
        type: TargetType.ACCOUNT,
        id: this.advertiserId,
        name: this.advertiserName
      }, {
        actionDetails: !isDeclined ? ActionDetails.INFLUENCER_REJECTED_REQUEST : ActionDetails.INFLUENCER_ACCEPTED_REQUEST,
        source: ActionSource.UNDO_LINK,
        permissionId: this.advertiserId,
        action: UserActionType.UPDATE
      }, undefined, null);
    } else {
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
        type: TargetType.CAMPAIGN,
        id: this.campaignInfluencer,
        name: this.campaignData && this.campaignData.campaign_name,
      }, {
        actionDetails: !isDeclined ? ActionDetails.INFLUENCER_REJECTED_REQUEST : ActionDetails.INFLUENCER_ACCEPTED_REQUEST,
        source: ActionSource.UNDO_LINK,
        campaignId: this.campaignId,
        action: UserActionType.UPDATE
      }, undefined, null);
    }
  }

  private declineCampaign(isRetried) {
    this.isDeclined = true;
    this.title = this.translate.instant('all_set.rejected_title');
    this.modalService.close();
    this.updateInfluencerCampaignInvitation(CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name).then(
      (success) => {
        this.notifySuccess(this.translate.instant('all_set.success_campaign_rejection'));
        if (!isRetried) {
          this.sendMixpanelEvent(this.isDeclined);
        }
      },
      (error) => {
        this.handleErrorOnCampaignInvitation(isRetried);
      }
    );
  }

  private accpetCampaign(isRetried) {
    this.modalService.close();
    if (!this.hasConfirmedAllChannels) {
      const data = {
        accessLevel: 'influencer',
        id: this.campaignInfluencer,
        status: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.name,
      };
      this.influencerService.updateInfluencerCampaignStatus(data).subscribe((res: any) => {
        return this.redirectToPreviousPage(true);
      });
    } else {
      this.isDeclined = false;
      this.title = this.translate.instant('all_set.title');
      this.updateInfluencerCampaignInvitation(CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name).then((success) => {
        if (!isRetried) {
          this.sendMixpanelEvent(this.isDeclined);
        }
        this.notifySuccess(this.translate.instant('all_set.success_campaign_acception'));
      },
        (error) => {
        this.handleErrorOnCampaignInvitation(isRetried);
      });
    }
  }

  private handleErrorOnCampaignInvitation(isRetried) {
    this.isDeclined = true;
    this.title = this.translate.instant('all_set.rejected_title');
    if (!isRetried) {
      this.errorType = InfluencerRequestError.ACCEPT_OR_REJECT_API_FAIL;
    }
    this.modalService.openInCenter(this.allSetPageErrorModal, null, 'all-set-page-error-modal');
  }

  private loadInfluencerChannels(influencerId) {
    this.influencerService.getInfluencerChannels(influencerId).subscribe((res) => {
      this.listExistingChannel = res;
      const igChannels = this.listExistingChannel.filter(ec => ec.platform.id === platformIconPath.instagram.id);
      const nonConfirmedIgChannels = igChannels.filter(ic => this.auth.hasAuthorizedIgChannel(ic.id));
      this.hasConfirmedAllChannels = nonConfirmedIgChannels.length === 0
        && this.listExistingChannel.filter(cn => cn.type !== ChannelStatus.AUTHORIZED).length === 0;
    });
  }

  private updateInfluencerCampaignInvitation(status) {
    return new Promise((resolve, reject) => {
      if (status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name) {
        this.influencerService.acceptCampaignInvitation(this.campaignId, this.currentInfluencer.id)
        .subscribe((res: any) => {
            resolve(res);
          }, (error) => {
            reject(error);
          }
        );
      } else if (status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name) {
        this.influencerService.declineCampaignInvitation(this.campaignId, this.currentInfluencer.id)
        .subscribe((res: any) => {
            resolve(res);
          }, (error) => {
            reject(error);
          }
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-all-set/influencer-all-set.component.ts